import requestCreater from '@/utils/request';
import { Env } from '@/utils/getEnv';

let accountHost = `https://account.huami.com`;
let apiUserHost = 'https://api-user.huami.com/';
if (Env === 'test' || Env === 'development') {
    accountHost = `https://account-staging.huami.com`;
    apiUserHost = 'https://api-user-staging.huami.com/';
}

export const ApiUserHost = apiUserHost;
export const AccountHost = accountHost;

export const ApiUserRequest = requestCreater(apiUserHost);
export const AccountRequest = requestCreater(accountHost);
